import React from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import HttpClient from './myapi';

const _webserver = HttpClient.WebServer + '/imgs/slides/';

const MyCarouselBig = ({ slides }) => {
    return (
        <Carousel
            swipeable={true}
            autoPlay
            infiniteLoop
        >
            {
                slides.map((img, key) => (
                    <div key={key}>
                        <img src={_webserver + img.srcnm} alt={"slide" + key} />

                    </div>
                ))
            }
        </Carousel>
    )
}

export default MyCarouselBig;


// WEBPACK FOOTER //
// ./src/MyCarousel.jsx